import React, {useRef, useCallback, useState, useEffect} from 'react';
import {SEQUENCE_TAG} from 'constants/annotation-types.js';
import ethereum from 'decentralized/ethereum.js';

export const useTags = ({work, numPending}) => {

    const [tags, setTags] = useState([]);

    useEffect(() => {
        if (!work) {
            return;
        }
        ethereum.xanadu.getAnnotations(SEQUENCE_TAG, work.newSequence)
            .then(x => 
                setTags(Array.from(new Set(x.map(a => a.annotationData))))
                 );
    }, [setTags, work]);

    const newTag = useCallback((text) => {
        if (text.trim() === "") {
            return;
        }
        ethereum.xanadu.newAnnotation(SEQUENCE_TAG, work.newSequence, text);
        setTags([... tags, text]);
    }, [work, tags, setTags]);
    
    return {newTag, tags, setTags};
};
